import React from "react";
// import Crdd
import Cards from "../assets/img/common/cardss.png";

const CopyRight = () => {
  return (
    <>
      <div className="copyright_area">
        <div className="container">
          <div className="row align-items-center">
            <div className="co-lg-12 col-md-12 col-sm-12 col-12">
              <div className="copyright_left text-center">
                <p>
                  Copyright © 2025 All Rights Reserved | Developed by{" "}
                  <a href="https://nascentinnovations.com/" target="_blank">
                    {" "}
                    Nascent Innovations
                  </a>
                </p>
              </div>
            </div>
            {/* <div className="co-lg-6 col-md-6 col-sm-12 col-12">
              <div className="copyright_right">
                <img src={Cards} alt="img" />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CopyRight;
